import { createFeatureSelector } from '@ngrx/store';
import { createSelector } from 'reselect';
import * as fromReportFilter from './report-filter.reducer';
import { ReportTypes } from '@mode/shared/contract-common';

export interface ReportFilterDomainState {
  [fromReportFilter.reportFilterFeatureKey]: fromReportFilter.State;
}

export const selectReportFilterState = createFeatureSelector<fromReportFilter.State>(
  fromReportFilter.reportFilterFeatureKey
);

export const selectTokens = createSelector(selectReportFilterState, (state) => state.tokens);

export const hasFilters = createSelector(selectTokens, (tokens) => !!tokens.length);

export const getFilters = (state: fromReportFilter.State) => state.filters;

export const selectFilterDefinitions = createSelector(selectReportFilterState, getFilters);

export const selectFilterDefinitionsArray = createSelector(selectTokens, selectFilterDefinitions, (tokens, filters) =>
  tokens.map((token) => filters[token])
);

export const selectFilterSelections = createSelector(selectReportFilterState, (state) => state.selections);
export const selectFilterCurrentSelections = createSelector(
  selectReportFilterState,
  (state) => state.currentSelections
);

export const selectFilterDefaults = createSelector(selectReportFilterState, (state) => state.defaults);

export const selectFilterOptions = createSelector(selectReportFilterState, (state) => state.options);

export const selectIsFiltersLoading = createSelector(selectReportFilterState, (state) => state.isFiltersLoading);
export const selectIsFiltersComplete = createSelector(selectReportFilterState, (state) => state.isFiltersComplete);

/**
 * Returns an object similar to ReportFilterControls. Excludes options, which are only
 * required for the embed selectors
 */
export const selectFilterControls = createSelector(selectReportFilterState, (state) => {
  return state.tokens.map((token) => {
    return {
      ...state.filters[token],
      selected: state.selections[token],
      default: state.defaults[token],
    } as ReportTypes.ReportFilterControl;
  });
});

/**
 * Report filter controls with the current selection state which may not be applied or persisted
 */
export const selectFilterControlsWithCurrentSelections = createSelector(
  selectReportFilterState,
  selectFilterControls,
  (state, controls) => {
    return controls.map((control) => {
      const selected = state.currentSelections[control.token] ?? control.selected;
      return <ReportTypes.ReportFilterControl>{
        ...control,
        selected,
      };
    });
  }
);
